/**
 * Permission utilities for frontend.
 *
 * P1-3 RBAC audit 2026-05-20: mirror backend `ecourt-api/app/core/permissions.py::ROLE_PERMISSIONS`.
 * LƯU Ý: phải sync khi backend đổi. Đây chỉ là gợi ý UI — backend luôn là source of truth.
 */

export type Role = 'secretary' | 'judge' | 'student' | 'support'

export type Permission =
  | 'MANAGE_USERS'
  | 'ASSIGN_CASES'
  | 'VIEW_CASES'
  | 'VIEW_OWN_CASE'
  | 'SCORE_CASES'
  | 'SUBMIT_MEMORIAL'
  | 'UPLOAD_EVIDENCE'
  | 'VIEW_AI_REPORTS'
  | 'MONITOR_SYSTEM'
  | 'CONFIGURE_SYSTEM'
  | 'VIEW_REPORTS'
  | 'MANAGE_SCHEDULE'
  | 'REGISTER_TEAM'
  | 'MANAGE_TEAM'
  | 'VIEW_TEAM_DASHBOARD'
  | 'HANDLE_SUPPORT_TICKETS'
  | 'VIEW_LOGS'
  | 'HARD_DELETE_USER'
  | 'REOPEN_COURTROOM'

const ROLE_PERMISSIONS: Record<string, Permission[]> = {
  secretary: [
    'MANAGE_USERS',
    'ASSIGN_CASES',
    'VIEW_CASES',
    'SCORE_CASES',
    'VIEW_AI_REPORTS',
    'MONITOR_SYSTEM',
    'CONFIGURE_SYSTEM',
    'VIEW_REPORTS',
    'MANAGE_SCHEDULE',
    'REGISTER_TEAM',
    'HARD_DELETE_USER',
    'REOPEN_COURTROOM',
  ],
  judge: ['VIEW_CASES', 'SCORE_CASES', 'VIEW_AI_REPORTS'],
  student: [
    'REGISTER_TEAM',
    'MANAGE_TEAM',
    'VIEW_OWN_CASE',
    'SUBMIT_MEMORIAL',
    'UPLOAD_EVIDENCE',
    'VIEW_TEAM_DASHBOARD',
  ],
  support: ['MANAGE_USERS', 'VIEW_CASES', 'MONITOR_SYSTEM', 'HANDLE_SUPPORT_TICKETS', 'VIEW_LOGS'],
}

export function hasPermission(role: string | undefined | null, permission: Permission): boolean {
  if (!role) return false
  const permissions = ROLE_PERMISSIONS[role] || []
  return permissions.includes(permission)
}

export function hasAnyPermission(
  role: string | undefined | null,
  permissions: Permission[],
): boolean {
  return permissions.some((p) => hasPermission(role, p))
}

export function hasRole(role: string | undefined | null, roles: Role[]): boolean {
  if (!role) return false
  return (roles as string[]).includes(role)
}

export function getPermissionsForRole(role: string): Permission[] {
  return ROLE_PERMISSIONS[role] || []
}
